import React, {useState} from 'react'
import addToMailchimp from 'gatsby-plugin-mailchimp'
import {Card, CardTitle, CardBody, Form, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap'

const NewsletterSignup = () =>  {
        const [email, setEmail] = useState('');
        const [firstName, setFirstName] = useState('');
        const [lastName, setLastName] = useState('');
        const [modal, setModal] = useState(false);

        const handleSubmit = function(e){
            e.preventDefault();
            addToMailchimp(email, {FNAME: firstName, LNAME: lastName})
            .then((data) => {
                toggle();
            })
            .catch((error) => {
                // Errors in here are client side
                // Mailchimp always returns a 200
            });
        };
        
        const handleEmailChange = function(event) {
            setEmail(event.currentTarget.value);
        };

        
        const handleFirstNameChange = function(event) {
            setFirstName(event.currentTarget.value);
        };

        
        const handleLastNameChange = function(event) {
            setLastName(event.currentTarget.value);
        };

        const toggle = () => setModal(!modal);
        
        return (
            <div>
                <Card>
                    <CardBody>
                        <CardTitle className="text-center text-uppercase mb-3">Newsletter</CardTitle>     
                        <Form onSubmit={handleSubmit}>
                                <Input
                                placeholder="Email address"
                                name="EMAIL"
                                type="text"
                                onChange={handleEmailChange}
                                />
                                <Input
                                placeholder="First name"
                                name="FNAME"
                                type="text"
                                onChange={handleFirstNameChange}
                                />
                                <Input
                                placeholder="Last name"
                                name="LNAME"
                                type="text"
                                onChange={handleLastNameChange}
                                />

                            <Button type="submit">Subscribe</Button>
                        </Form>
                    </CardBody>
                </Card>   
                <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle}>Thanks for subscribing!</ModalHeader>
                    <ModalBody>
                    We really appreciate you signing up for the newsletter and look forward to sending you useful developer
                    productivity information on a regular basis!
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={toggle}>Close</Button>
                    </ModalFooter>
                </Modal>
        </div>
        )
    }

    export default NewsletterSignup;